import type { IDWStation, IDWResult } from './types';

const IDW_POWER = 2.5;

/**
 * Inverse Distance Weighting interpolation of the wind vector at a
 * geographic point. Ported (wind-only) from sites/my-fdi/src/utils/idw.ts.
 */
export function idwAt(lat: number, lng: number, stations: IDWStation[]): IDWResult {
  if (!stations.length) {
    return { u: 0, v: 0, speedKt: 0, fade: 1 };
  }

  let sw = 0, su = 0, sv = 0;

  for (const s of stations) {
    const cosLat = Math.cos((lat + s.lat) * 0.5 * Math.PI / 180);
    const dLon = (lng - s.lng) * cosLat;
    const dLat = lat - s.lat;
    const dist = Math.sqrt(dLon * dLon + dLat * dLat) + 0.005;
    const w = 1 / Math.pow(dist, IDW_POWER);
    sw += w;
    su += s.u * w;
    sv += s.v * w;
  }

  const u = su / sw;
  const v = sv / sw;
  return {
    u,
    v,
    speedKt: Math.sqrt(u * u + v * v) * 1.94384,
    fade: 1,
  };
}
